<template>
    <div class="standalone-video-controls" :class="{ disabled }">
        <div class="standalone-video-buttons">
<!--            <video-seek-mode-selector-->
<!--                class="mr-3"-->
<!--                variant="dark"-->
<!--                :video-seek-mode="videoSeekMode"-->
<!--                boundary="viewport"-->
<!--                @videoSeekModeChanged="changeSeekMode"-->
<!--            />-->

            <player-navigation
                :play-state="playState"
                :video-seek-mode="videoSeekMode"
                @playToggled="playHandler"
                @skipClicked="skip"
            />

<!--            <time-skip-amount-handler-->
<!--                v-if="videoSeekMode === VIDEO_SEEK_MODES.TIME"-->
<!--                :skip-frames-amount="skipFramesAmount"-->
<!--                :delay-between-cycles_m="delayBetweenCycles_m"-->
<!--                boundary="viewport"-->
<!--                @skipFramesAmountChanged="frameSkipAmountChangeHandler"-->
<!--            />-->

            <event-skip-amount-handler
                v-if="videoSeekMode === VIDEO_SEEK_MODES.MK_EVENT"
                :event-names="wellMKEventsName"
                :selected-event-name="selectedMKEvent && selectedMKEvent.systemName"
                boundary="viewport"
                @eventChosen="goToMkEvent"
            />
<!--            <event-skip-amount-handler-->
<!--                v-if="videoSeekMode === VIDEO_SEEK_MODES.ISTANBUL_EVENT"-->
<!--                :event-names="filteredIstanbulEventsNames"-->
<!--                :selected-event-name="selectedIstanbulEvent && selectedIstanbulEvent.label"-->
<!--                boundary="viewport"-->
<!--                @eventChosen="goToIstanbulEvent"-->
<!--            />-->
            <event-skip-amount-handler
                v-if="videoSeekMode === VIDEO_SEEK_MODES.DAY"
                :event-names="filteredDaysNames"
                :selected-event-name="selectedDay && selectedDay.label"
                :is-day-mode="true"
                boundary="viewport"
                @eventChosen="goToDay"
            />
        </div>

<!--        <video-brightness-slider />-->
<!--        <i class="fa fa-sun-o" />-->

<!--        <video-invert-toggle />-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Utils from '../../../business/utils/Utils'
import { VIDEO_SEEK_MODES } from '../../../business/const'
import VideoBrightnessSlider from './VideoBrightnessSlider'
import VideoInvertToggle from './VideoInvertToggle'
import PlayerNavigation from '../video/PlayerNavigation'
import EventSkipAmountHandler from '../video/EventSkipAmountHandler'

export default {
    name: 'StandaloneVideoControls',
    components: {
        PlayerNavigation,
        EventSkipAmountHandler,

        VideoInvertToggle,
        VideoBrightnessSlider,

    },
    props: [
        'well',
        'disabled',
        'delayBetweenCycles_m',
        'playState',
        'selectedMKEvent',
        'selectedIstanbulEvent',
        'selectedDay',
        'skipFramesAmount',
        'hoursSinceFertilization'
    ],
    data() {
        return {
            videoSeekMode: VIDEO_SEEK_MODES.TIME,
            filteredIstanbulEvents: Utils.filterIstanbulEventsByHoursSinceFertilization(
                this.hoursSinceFertilization
            ),
            VIDEO_SEEK_MODES
        }
    },
    computed: {
        ...mapGetters({
            getStartingHourOfSelectedSlide: 'timelapse/getStartingHourOfSelectedSlide'
        }),
        wellMKEventsName() {
            return this.well.inferenceData.morphokinetics.map(_event => _event.systemName)
        },
        filteredIstanbulEventsNames() {
            return this.filteredIstanbulEvents.map(event => event.label)
        },
        filteredDays() {
            return Utils.filterDaysByHoursSinceFertilization(
                this.hoursSinceFertilization,
                this.getStartingHourOfSelectedSlide
            )
        },
        filteredDaysNames() {
            return this.filteredDays.map(event => event.label)
        }
    },
    methods: {
        frameSkipAmountChangeHandler(amount) {
            this.$emit('skipFramesAmountChanged', amount)
        },
        skip(isForward) {
            if (this.videoSeekMode === VIDEO_SEEK_MODES.TIME) {
                this.$emit('skipVideo', isForward)
            } else if (this.videoSeekMode === VIDEO_SEEK_MODES.MK_EVENT) {
                const targetEvent = Utils.getNextPreviousItem(
                    isForward,
                    this.well.inferenceData.morphokinetics,
                    this.selectedMKEvent
                )
                this.goToMkEvent(targetEvent.systemName)
            } else if (this.videoSeekMode === VIDEO_SEEK_MODES.ISTANBUL_EVENT) {
                const targetEvent = Utils.getNextPreviousItem(
                    isForward,
                    this.filteredIstanbulEvents,
                    this.selectedIstanbulEvent
                )
                this.goToIstanbulEvent(targetEvent.label)
            } else if (this.videoSeekMode === VIDEO_SEEK_MODES.DAY) {
                const targetEvent = Utils.getNextPreviousItem(
                    isForward,
                    this.filteredDays,
                    this.selectedDay
                )
                this.goToDay(targetEvent.label)
            }
        },
        playHandler(status) {
            this.$emit('playStateChanged', status)
        },
        goToMkEvent(mkEventSN) {
            let selected = null

            const morphokinetics = this.well.inferenceData.morphokinetics

            for (const rangeMetric of morphokinetics) {
                if (rangeMetric.systemName === mkEventSN) {
                    selected = rangeMetric
                    break
                }
            }
            if (selected != null) {
                this.$emit('skipToMkEvent', selected)
            }
        },
        goToIstanbulEvent(istanbulEvent) {
            const event = this.filteredIstanbulEvents.find(event => event.label === istanbulEvent)
            if (event) {
                this.$emit('skipToIstanbulEvent', event)
            }
        },
        goToDay(dayName) {
            const day = this.filteredDays.find(day => day.label === dayName)
            if (day) {
                this.$emit('skipToDay', day)
            }
        },
        changeSeekMode(value) {
            this.videoSeekMode = value
        }
    }
}
</script>

<style lang="scss">
.standalone-video-controls {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;

    .standalone-video-buttons {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .video-brightness-slider {
        width: 35%;
    }
    .fa-sun-o {
        font-size: 14pt;
    }

    .disabled {
        pointer-events: none;
    }

    @media screen and #{$new-break3}, #{$new-break4} {
        .standalone-video-buttons {
            width: 50vw;
            height: $well-video-controls-bottom-panel-height;
            position: fixed;
            bottom: 0;
            left: 0;
            background-color: $dark-5;
            z-index: 99;

            .player-navigation {
                flex-grow: 1;
            }
        }

        .video-brightness-slider,
        .fa-sun-o,
        .video-invert-toggle {
            display: none;
        }
    }
}
</style>
